<!-- Sales by service Report -->
<div class="surface-0 border-round shadow-2 md:flex align-items-center mb-3" *ngIf="reportKey.toLowerCase() == 'salesbyservicecategory'">
  <!-- Left Side -->
  <div class="px-3 py-3 md:py-5 md:w-3 xl:w-2 text-center text-md-left">
      <h6 class="font-medium text-700 text-xs mb-2 block uppercase">{{'REPORTS.REPORT_TEMPLATE.TOTAL_COLLECTION' | translate }}</h6>
      <strong class="block text-green-400 text-xl xl:text-2xl">{{ getTotalAmount() | currencyformat}}</strong>
      <span class="block text-sm mt-2 md:mt-4">
          {{'REPORTS.REPORT_TEMPLATE.TOTAL_TAX' | translate }} <strong>{{ getTaxTotal() | currencyformat}}</strong>
          <p>({{'REPORTS.REPORT_TEMPLATE.TAX_NOTE' | translate }})</p>
      </span>
  </div>
  <!-- Left Side -->

  <!-- Right Side -->
  <div class="md:w-9 xl:w-10 p-3 md:border-top-0 md:border-left-1 border-300">
      <p-table [value]="statisticsData" styleClass="" responsiveLayout="scroll">
          <ng-template pTemplate="header">
              <tr>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{'ADMIN.SUBSCRIPTION.SERVICE_CATEGORY' | translate }}</span></th>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{'REPORTS.REPORT_TEMPLATE.SALES_AMOUNT_EXLD_TAX' | translate }}</span></th>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{'REPORTS.REPORT_TEMPLATE.TAX_AMOUNT' | translate }}</span></th>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{ 'REPORTS.REPORT_TEMPLATE.COLLECTED_AMOUNT' | translate }}</span></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-collection>
              <tr class="text-sm">
                  <td class="py-3 white-space-nowrap">{{collection.service_categories}}</td>
                  <td class="py-3 white-space-nowrap">{{collection.sale_amount | currencyformat}}</td>
                  <td class="py-3 white-space-nowrap">{{collection.tax_amount | currencyformat}}</td>
                  <td class="py-3 white-space-nowrap"><strong>{{collection.total_payments | currencyformat}}</strong></td>
              </tr>
          </ng-template>
      </p-table>
  </div>
  <!-- Right Side -->
</div>
<!-- Sales by service Report -->

<!-- Payment Report -->
<div class="surface-0 border-round shadow-2 md:flex align-items-center mb-3" *ngIf="reportKey.toLowerCase() == 'paymentreport'">
  <!-- Left Side -->
  <div class="px-3 py-3 md:py-5 md:w-3 xl:w-2">
      <h6 class="text-xs mb-3">{{'REPORTS.REPORT_TEMPLATE.TOTAL_REVENUE' | translate}}</h6>
      <strong class="block text-green-400 text-xl xl:text-2xl">{{ getTotalAmount() | currencyformat }}</strong>
  </div>
  <!-- Left Side -->

  <!-- Right Side -->
  <div class="md:block md:w-9 xl:w-10 px-3 pb-2 pt-3 md:border-top-0 md:border-left-1 border-300">
      <div class="grid">
          <!-- Column -->
          <div class="col-6 md:col-3 xl:col-2" *ngFor="let data of statisticsData; let i = index">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{getMode(data.pymt_log_paymode_level2_id,data)}}</label>
              <strong class="block">{{data.amt | currencyformat}}</strong>
          </div>
          <!-- Column -->
      </div>
  </div>
  <!-- Right Side -->
</div>
<!-- Payment Report -->

<!-- Invoice Report -->
<div class="surface-0 border-round shadow-2 md:flex align-items-center mb-3" *ngIf="reportKey.toLowerCase() == 'invoicedetail'">
  <!-- Left Side -->
  <div class="px-3 py-3 md:py-5 md:w-3 xl:w-2 text-center text-md-left">
      <h6 class="font-medium text-700 text-xs mb-2 block uppercase">{{'REPORTS.REPORT_TEMPLATE.TOTAL_COLLECTION' | translate }}</h6>
      <strong class="block text-green-400 text-xl xl:text-2xl">{{getTotalAmount() | currencyformat}}</strong>
      <span class="block text-sm mt-2 md:mt-4">
          {{'REPORTS.REPORT_TEMPLATE.TOTAL_TAX' | translate }} <strong>{{getTaxTotal() | currencyformat}}</strong>
          <p>({{'REPORTS.REPORT_TEMPLATE.TAX_NOTE' | translate }})</p>
      </span>
  </div>
  <!-- Left Side -->

  <!-- Right Side -->
  <div class="md:w-9 xl:w-10 p-3 md:border-top-0 md:border-left-1 border-300">
      <p-table [value]="statisticsData" styleClass="" responsiveLayout="scroll">
          <ng-template pTemplate="header">
              <tr>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{'REPORTS.REPORT_TEMPLATE.SERVICE_CHARGE_CATEGORY' | translate }}</span></th>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{'REPORTS.REPORT_TEMPLATE.SALES_AMOUNT_EXLD_TAX' | translate }}</span></th>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{'REPORTS.REPORT_TEMPLATE.TAX_AMOUNT' | translate }}</span></th>
                  <th class="surface-100"><span class="text-xs text-600 white-space-nowrap">{{ 'REPORTS.REPORT_TEMPLATE.COLLECTED_AMOUNT' | translate }}</span></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-collection>
              <tr class="text-sm">
                  <td class="py-3 white-space-nowrap">{{collection.service_charge_categories}}</td>
                  <td class="py-3 white-space-nowrap">{{collection.sale_amount | currencyformat}}</td>
                  <td class="py-3 white-space-nowrap">{{collection.tax_amount | currencyformat}}</td>
                  <td class="py-3 white-space-nowrap"><strong>{{collection.total_payments | currencyformat}}</strong></td>
              </tr>
          </ng-template>
      </p-table>
  </div>
  <!-- Right Side -->
</div>
<!-- Invoice Report -->


<!-- clientsbyservicecategory Report -->
<div class="surface-0 border-round shadow-2 md:flex align-items-center mb-3" *ngIf="reportKey.toLowerCase() == 'clientsbyservicecategory'">
  <!-- Left Side -->
  <!-- <div class="px-3 py-3 md:py-5 md:w-3 xl:w-2">
      <h6 class="text-xs mb-3">{{'REPORTS.REPORT_TEMPLATE.TOTAL_REVENUE' | translate}}</h6>
      <strong class="block text-green-400 text-xl xl:text-2xl">{{ getTotalAmount() | currencyformat }}</strong>
  </div> -->
  <!-- Left Side -->

  <!-- Right Side -->
  <div class="md:block md:w-9 xl:w-10 px-3 pb-2 pt-3 md:border-top-0 md:border-left-1 border-300">
      <div class="grid">
          <!-- Column -->
          <div class="col-6 md:col-3 xl:col-2" *ngFor="let data of statisticsData; let i = index">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{data.CategoryPrimaryName}}</label>
              <strong class="block">{{data.Count}}</strong>
          </div>
          <!-- Column -->
      </div>
  </div>
  <!-- Right Side -->
</div>
<!-- clientsbyservicecategory Report -->

<!-- clientsbyservicecategory Report -->
<div class="surface-0 border-round shadow-2 md:flex align-items-center mb-3" *ngIf="reportKey.toLowerCase() == 'countbymembercategorywise'">
   <!-- Left Side -->
  <div class="px-3 py-3 md:py-5 md:w-3 xl:w-2">
    <h6 class="text-xs mb-3">{{'REPORTS.REPORT_TEMPLATE.TOTAL' | translate}}</h6>
    <strong class="block text-green-400 text-xl xl:text-2xl">{{ getTotal() | number }}</strong>
</div>
<!-- Left Side -->

<!-- Right Side -->
<div class="md:block md:w-9 xl:w-10 px-3 pb-2 pt-3 md:border-top-0 md:border-left-1 border-300">
    <div class="grid">
        <!-- Column -->
        <div class="col-6 md:col-3 xl:col-2" *ngFor="let data of statisticsData; let i = index">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{data.tent_name_pri_lang}}</label>
            <strong class="block">{{data.cnt}}</strong>
        </div>
        <!-- Column -->
    </div>
  </div>
  <!-- clientsbyservicecategory Report -->
